import { Chip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    pageCount: {
        position: "fixed",
        left: theme.spacing(1),
        bottom: theme.spacing(1)
    }
}));

interface Props
{
    page: number,
    total: number
}

export default function PageCount({ page, total }: Props)
{
    const classes = useStyles();
    return <Chip className={classes.pageCount} sx={{ displayPrint: 'none' }} variant={"outlined"} label={`${page} / ${total}`} />
}